








































































import { Component, Vue } from "vue-property-decorator";
import { LAPORAN_KEBIDANAN_CARDS } from "@/config/sidebar-menu";
import { userModule } from "@/store/modules/user";

interface LaporanKebidananCard {
  key: string;
  route: string | null;
  title: string;
  subtitle: string;
  desc: string;
  icon: string;
  color: string;
  privilege: { domain: string; action?: string };
  alasan: string | null;
}

@Component
export default class LaporanKebidananMenuPage extends Vue {
  get visibleCards(): LaporanKebidananCard[] {
    return (LAPORAN_KEBIDANAN_CARDS as LaporanKebidananCard[]).filter(card =>
      userModule.hasPrivilege(
        card.privilege.domain,
        card.privilege.action || "view"
      )
    );
  }

  goto(card: LaporanKebidananCard) {
    if (!card.route) return;
    this.$router.push({ name: card.route }).catch(() => undefined);
  }
}
